<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 240px'>
        <p>对账单编号：</p>
        <el-input v-model='searchForm.settNo' size='mini' style='width:150px' placeholder='请输入对账单编号' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>标题：</p>
        <el-input v-model='searchForm.title' size='mini' style='width:150px' placeholder='请输入标题' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>结算方式：</p>
        <el-select v-model='searchForm.settType' filterable size='mini' style='width:150px' placeholder='请选择结算方式'>
          <el-option v-for='item in typeOption' :key='item.label' :label='item.label' :value='item.value' />
        </el-select>
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>委托商：</p>
        <el-input v-model='searchForm.companyName' size='mini' style='width:150px' placeholder='请输入委托商' />
      </div>
      <div class='navContainer' style='width: 420px'>
        <p style='width: 120px'>对账单生成时间：</p>
        <el-date-picker v-model='searchForm.startTime' size='mini' style='width:150px' value-format='yyyy-MM-dd'
                        @change='dateChange' type='date' placeholder='开始日期' />
        <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
        <el-date-picker v-model='searchForm.endTime' size='mini' style='width:150px' value-format='yyyy-MM-dd'
                        @change='dateChange' type='date' placeholder='结束日期' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p >状态：</p>
        <el-select v-model='searchForm.status' filterable size='mini' style='width:150px' placeholder='请选择状态'>
          <el-option v-for='item in stateOption' :key='item.label' :label='item.label' :value='item.value' />
        </el-select>
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>对账人员：</p>
        <el-input v-model='searchForm.reconciliator' size='mini' style='width:170px' placeholder='请输入对账人员' />
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span style="color: red;">{{ msg }}</span>
        <span @click='exportData'>详情批量导出</span>
        <span @click="exportDatas">导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table v-loading='tableLoad' :data='TableDatas' style='width: 100%' max-height='600px' ref='listTable' border
                  :header-cell-style='headerCellStyle' :cell-style='cellStyle' :expand-row-keys='expands'
                  @selection-change='selectionDataChange' :row-style="rowStyle">
          <el-table-column type='selection' align='center' width='50px' />
          <el-table-column prop='settNo' label='对账单编号' width='170' align='center' show-overflow-tooltip />
          <el-table-column prop='title' label='标题' align='center' width='150' show-overflow-tooltip />
          <el-table-column label='结算方式' prop='settType' align='center' width="150" :formatter='settTypeFormat' />
          <el-table-column prop="companyNameNew" label='委托商' width='150' align='center' :show-overflow-tooltip='true'/>
          <el-table-column prop='taxRate' label='税率（%）' align='center' width="90px"/>
          <el-table-column prop='taxPrice' label='差价' align='center' width="90px"/>
          <el-table-column prop="settINum" label="结算数量" width="140" align="center" show-overflow-tooltip />
          <el-table-column prop='settlementPrice' label='合同价' align='center' width="90px"/>
          <el-table-column prop='taxSettPrice' label='预结算价' align='center' width="90px"/>
          <el-table-column prop='otherPrice' label='其他费用' align='center' width="90px"/>
          <!-- <el-table-column label='发票号' align='center' width='150' show-overflow-tooltip >
            <template slot-scope='scope' style='display:flex;align-items:center;justify-content:center'>
              <span>
              {{getInvoiceNo(scope.row)}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label='发票时间' align='center' width='150' show-overflow-tooltip >
            <template slot-scope='scope' style='display:flex;align-items:center;justify-content:center'>
              <span>
              {{getInvoiceCreateTime(scope.row)}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label='发票金额' align='center' width='150' show-overflow-tooltip >
            <template slot-scope='scope' style='display:flex;align-items:center;justify-content:center'>
              <span>
              {{getInvoicePrice(scope.row)}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="发票税率" prop="invoiceTaxRate" align="center" width="150" show-overflow-tooltip></el-table-column> -->
          <el-table-column label="发票号" prop="invoiceNo" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="发票时间" prop="invoiceDate" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="发票金额" prop="invoicePrice" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="发票税率" prop="invoiceTaxRate" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="发票代码" prop="invoiceCode" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop='createTime' label='生成时间' width='140' align='center' show-overflow-tooltip />
          <el-table-column prop='endDate' label='已开票' align='center'>
            <template slot-scope='scope' style='display:flex;align-items:center;justify-content:center'>
              <span>
                {{
                  scope.row.isBillingType === 0
                    ? '暂未开票' : scope.row.isBillingType === 1
                      ? '已开票' : '暂未开票'
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop='status' label='状态' align='center'>
            <div slot-scope='scope'>{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label="推送状态" width="140" align="center" show-overflow-tooltip>
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span>{{ scope.row.isSend==1?'已推送':'未推送' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop='reconciliator' label='对账人员' width='140' align='center' show-overflow-tooltip />
          <el-table-column prop='remark' label='备注' width='140' align='center' show-overflow-tooltip />

          <!--          <el-table-column prop='operateRecord.operationName' label='操作人' width='140' align='center' show-overflow-tooltip />-->
          <el-table-column label='操作' width='460' align='center' fixed='right'>
            <!-- childrenType 100：子数据 0：父数据-->
            <template slot-scope='scope'>
              <div>
                <el-tooltip placement='bottom' v-if='scope.row.show' effect='light'>
                  <div slot='content'>
                    <span style='color: rgb(16, 16, 16);font-weight: 700;'>提示</span><br />
                    <span>预结算超出合同价，已记录到 <span
                      style='color: rgb(58, 98, 215);text-decoration: underline;cursor: pointer;'
                      @click="$router.push('/settle/exceedContract');">补结算管理</span> 页面中，下次结算可以选择是否抵消当前超出费用！</span>
                  </div>
                  <i class='el-icon-warning' style='color: red;font-size: 18px;margin-right: 5px;' />
                </el-tooltip>
                <el-button v-if='scope.row.isHongchong != 1 && scope.row.status === 0 || scope.row.status === -1 ' size='mini' class='searchBtn btnTopBottom10' type='primary' @click=' changeClick(scope.row.id) '>核对对账单</el-button>
                <el-button v-if="scope.row.isHongchong != 1" size='mini' class='searchBtn btnTopBottom10' type='primary' @click=' detailClick(scope.row.id) '>详情</el-button>
                <el-button v-if='scope.row.isHongchong != 1 && scope.row.status === 0 || scope.row.status === -1 ' size='mini' type='primary' @click=' auditClick(scope.row.id,scope.row.reconciliator) ' class="btnTopBottom10">提交审核</el-button>
                <el-button v-if='scope.row.isHongchong != 1 && scope.row.status === 1 ' size='mini' type='danger' @click=' disableClick(scope.row.id,scope.row.reconciliator) ' class="btnTopBottom10">取消审核</el-button>
                <el-button v-if='scope.row.isHongchong != 1 && scope.row.status === 3 ' size='mini' type='primary' @click=' invoiceClick(scope.row.id) ' class="btnTopBottom10">寄送发票</el-button>
                <el-button v-if='scope.row.isHongchong != 1 && scope.row.status === 0 || scope.row.status === -1 ' size='mini' type='info' @click=' deleteClick(scope.row.id,scope.row.reconciliator) ' class="btnTopBottom10">删除</el-button>
                <el-button v-if='scope.row.isHongchong != 1 && scope.row.status === 0 ' size='mini' type='primary' @click=' titleChange(scope.row.id,scope.row.reconciliator) ' class="btnTopBottom10">更改标题</el-button>
                <el-button v-if='scope.row.isSend == 0' size='mini' type='primary' @click='dataPush(scope.row.id,scope.row.reconciliator, scope) ' class="btnTopBottom10">推送</el-button>
                <el-button v-if="scope.row.isHongchong != 1 && scope.row.isSend == 1" size="mini" type="primary" @click="onClickVoid(scope.row)" class="btnTopBottom10">作废</el-button>
                <!-- <el-button v-if='scope.row.isHongchong != 1 && scope.row.isSend === 1 ' size='mini' type='primary' @click='cancelPush(scope.row.id) ' class="btnTopBottom10">取消推送</el-button> -->
                <el-button v-if="scope.row.isHongchong != 1" size="mini" type="primary" @click="editRemark(scope.row)" class="btnTopBottom10">修改备注</el-button>
                <el-button v-if="scope.row.isHongchong != 1" size="mini" type="danger" @click="hongChong(scope.row)" class="btnTopBottom10">红冲</el-button>
                  <!--                  <el-button v-if='scope.row.status === 2' size='mini' type='primary'
                                               :loading='invoicingLoading' @click='submitBillingClick(scope.row.id)'>
                                      提交开票
                                    </el-button>-->
                  <!--                  <el-button v-if='scope.row.status === 2' size='mini' type='primary'
                                               @click='fillInInvoice(scope.row.id)'>填写发票
                                    </el-button>-->
                  <!--                  <el-button v-if='scope.row.status === 2' size='mini' type='primary'-->
                  <!--                             @click='addContractPrice(scope.row.id)'>添加合同价-->
                  <!--                  </el-button>-->

              </div>
              <!--              <div>-->
              <!--                <div style='display:flex;align-items:center;padding-left: 10px;justify-content: center'-->
              <!--                  v-if=' searchForm.type === 10 || scope.row.settType === 1 || scope.row.settType === 3'>-->
              <!--                  <el-tooltip placement='bottom' v-if=' scope.row.show ' effect='light'>-->
              <!--                    <div slot='content'>-->
              <!--                      <span style='color: rgb(16, 16, 16);font-weight: 700;'>提示</span><br />-->
              <!--                      <span>预结算超出合同价，已记录到-->
              <!--                        <span style='color: rgb(58, 98, 215);-->
              <!--                          text-decoration: underline;-->
              <!--                          cursor: pointer;' @click=" $router.push('/settle/exceedContract'); ">-->
              <!--                          补结算管理-->
              <!--                        </span>-->
              <!--                        页面中，下次结算可以选择是否抵消当前超出费用！-->
              <!--                      </span>-->
              <!--                    </div>-->
              <!--                    <i class='el-icon-warning' style='color: red;font-size: 18px;margin-right: 5px;' />-->
              <!--                  </el-tooltip>-->
              <!--                  <el-button v-if=' !scope.row.status ' size='mini' class='searchBtn' type='primary'-->
              <!--                    @click=' changeClick(scope.row.id) '>核对对账单-->
              <!--                  </el-button>-->
              <!--                  <el-button size='mini' class='searchBtn' type='primary' @click=' detailClick(scope.row.id) '>详情-->
              <!--                  </el-button>-->
              <!--                  <el-button v-if=' !scope.row.status ' size='mini' type='primary'-->
              <!--                    @click=' auditClick(scope.row.id) '>提交审核-->
              <!--                  </el-button>-->
              <!--                  <el-button v-if=' scope.row.status === 1 ' size='mini' type='danger'-->
              <!--                    @click=' disableClick(scope.row.id) '>取消审核-->
              <!--                  </el-button>-->
              <!--                  &lt;!&ndash;                  <el-button v-if='scope.row.status===1' size='mini' class='yellow-bg'-->
              <!--                                               type='primary'>-->
              <!--                                      添加对账单-->
              <!--                                    </el-button>&ndash;&gt;-->
              <!--                  <el-button v-if=' scope.row.status === 3 ' size='mini' type='primary'-->
              <!--                    @click=' invoiceClick(scope.row.id) '>寄送发票-->
              <!--                  </el-button>-->
              <!--                  <el-button v-if=' !scope.row.status ' size='mini' type='info' @click=' deleteClick(scope.row.id) '>删除-->
              <!--                  </el-button>-->
              <!--                  <el-button v-if=' scope.row.status === 0 ' size='mini' type='primary'-->
              <!--                    @click=' titleChange(scope.row.id) '>更改标题-->
              <!--                  </el-button>-->
              <!--                  &lt;!&ndash;                  <el-button v-if='scope.row.status === 2' size='mini' type='primary'-->
              <!--                                               :loading='invoicingLoading'-->
              <!--                                               @click='submitBillingClick(scope.row.id)'>-->
              <!--                                      提交开票-->
              <!--                                    </el-button>&ndash;&gt;-->
              <!--                  &lt;!&ndash;                  <el-button v-if='scope.row.status === 2' size='mini' type='primary'-->
              <!--                                               @click='fillInInvoice(scope.row.id)'>填写发票-->
              <!--                                    </el-button>&ndash;&gt;-->
              <!--                </div>-->
              <!--                <span>&#45;&#45;</span>-->
              <!--              </div>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes=' [10, 20, 30] ' layout='sizes,prev, pager, next,jumper' :total=' total '
                       @size-change=' contractSizeChange ' @current-change=' contractCurrentChange '
                       @prev-click=' contractCurrentChange ' @next-click=' contractCurrentChange ' />
      </div>
    </div>
    <!--    详情对话框 start-->
    <el-dialog title='详情' :visible.sync=' detailDialogVisible ' :width=' detailDialogWidth ' @close=' detailClose ' center
               top='10vh'>
      <div class='detail'>
        <el-tabs v-model=' activeName1 '>
          <el-tab-pane label='基础信息' name='first'>
            <div class='baseInfo'>
              <div class='baseInfoContent'>
                <div class='baseInfoContentItem'>
                  <span class='span1'>对账单编号：</span>
                  <span>{{ detailData.settNo }}</span>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>标题：</span>
                  <span>{{ detailData.title }}</span>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>委托商：</span>
                  <span>{{ detailData.companyNameNew }}</span>
                  <el-tooltip v-if=' detailData.companyNameOld != detailData.companyNameNew ' placement='bottom'
                              effect='light'>
                    <div slot='content'>
                      <span style='color: #999;'>原委托商名称：{{ detailData.companyNameOld }}</span>
                    </div>
                    <i class='el-icon-warning' style='color: red;font-size: 18px;margin-right: 5px;' />
                  </el-tooltip>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>结算方式：</span>
                  <span>{{ detailData.settType === 1 ? '合同价' : detailData.settType === 2?'预结算价':'合同价/预结算价' }}</span>
                </div>
                <div class='baseInfoContentItem specialItem'>
                  <div class='specialOne' style="width: 250px">
                    <span class='span1'>差价：</span>
                    <span>{{ detailData.taxPrice || 0}}元</span>
                  </div>
                  <div style="width: 250px">
                    <span class='span1'>合同价：</span>
                    <span>{{ detailData.settlementPrice  || 0 }}元</span>
                  </div>
                  <div style="width: 250px">
                    <span class='span1'>预结算价：</span>
                    <span>{{ detailData.taxSettPrice || 0}}元</span>
                  </div>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>台账月汇总金额：</span>
                  <span>{{ detailData.statistics }}</span>
                </div>
                <!--                <div class="baseInfoContentItem">-->
                <!--                  <span class="span1">生成对账单时间：</span>-->
                <!--                  <span>{{detailData.time2}}</span>-->
                <!--                </div>-->
              </div>
            </div>
            <div class='operation' v-if=' detailData.isDeduct == 1 '>
              <div class='operationTitle'>
                <div class='line' />
                <span>抵扣对账单</span>
              </div>
              <div class='operationTable'>
                <el-table :data=' detailData.table1 ' border>
                  <el-table-column label='序号' align='center' type='index' />
                  <el-table-column prop='operateType' label='对账单编号' align='center' />
                  <el-table-column prop='operationName' label='抵扣费用' align='center' />
                </el-table>
              </div>
            </div>
            <div class='baseInfo' v-if=' detailData.status == 1 || detailData.status == 2 '>
              <div class='baseInfoTitle'>
                <div class='line' />
                <span>审核信息</span>
              </div>
              <div>
                <steps :step-data=' stepData ' :step-state=' stepState ' />
              </div>
            </div>
            <div class='operation'>
              <div class='operationTitle'>
                <div class='line' />
                <span>操作记录</span>
              </div>
              <div class='operationTable'>
                <el-table :data=' operationData ' border>
                  <el-table-column label='操作时间' align='center' width='160px'>
                    <div slot-scope='scope'>{{ getTime(scope.row.createTime) }}</div>
                  </el-table-column>
                  <el-table-column prop='operateType' label='操作类型' align='center' />
                  <el-table-column prop='operationName' label='操作人' align='center' />
                  <el-table-column prop='remark' label='备注' align='center' />
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label='结算费用' name='second'>
            <div class='baseInfo'>
              <div class='operationTable' style='margin-top:0;'>
                <el-table :data=' detailTable ' border script>
                  <el-table-column prop='batchNumber' label='批次号' min-width='100' align='center' show-overflow-tooltip />
                  <el-table-column prop='waybillNo' label='运单号' min-width='120' align='center' show-overflow-tooltip />
                  <el-table-column prop='frameNumber' label='车架号' min-width='150' align='center' show-overflow-tooltip />
                  <el-table-column label='运输方式' min-width='120' align='center' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      {{
                        scope.row.transportationTerms === 1 ? '公路' : scope.row.transportationTerms === 2 ? '水路' : '水陆联运'
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column prop='brandName' label='品牌' align='center' show-overflow-tooltip />
                  <el-table-column prop='modelName' label='型号' align='center' show-overflow-tooltip />
                  <el-table-column prop='startPortName' label='起始地' min-width='150' align='center' show-overflow-tooltip/>
                  <el-table-column prop='deliveryPortName' label='交车地' min-width='150' align='center' show-overflow-tooltip/>
                  <el-table-column prop='taxRate' label='税率' align='center' />
                  <el-table-column prop='standingBookMonth' label='台账月' min-width='100' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='taxContractPrice' label='含税合同价' align='center'
                                   show-overflow-tooltip />
                  <el-table-column   prop='taxPreparePrice' label='含税预结算价' align='center' show-overflow-tooltip />
                  <el-table-column prop='difPrice' label='差价' align='center' width="90px"/>
                </el-table>
              </div>
              <div class='paginationContainer' style='display: flex;align-items: center;padding: 10px 20px;'>
                <span>共{{ detailTotal }}条</span>
                <el-pagination background :page-sizes=' [10, 20, 30, 40] ' layout='sizes,prev, pager, next,jumper'
                               :total=' detailTotal ' @size-change=' detailSizeChange ' @current-change=' detailCurrentChange '
                               @prev-click=' detailCurrentChange ' @next-click=' detailCurrentChange ' />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label='其它结算费用' name='third'>
            <div class='baseInfo'>
              <div class='operationTable' style='margin-top:0'>
                <el-table :data=' detailTable3 ' border script>
                  <el-table-column label='序号' align='center' type='index' />
                  <el-table-column prop='costNum' label='费用编号' align='center' />
                  <el-table-column prop='costTypeName' label='费用类型' align='center' />
                  <el-table-column prop='costInstruction' label='费用说明' align='center' />
                  <el-table-column prop='costTime' label='费用时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.costTime |publicFormatTime }}
                    </template>
                  </el-table-column>
                  <el-table-column prop='taxRate' label='税率(%)' align='center' />
                  <el-table-column prop='costAmount' label='含税价' align='center' />
                  <el-table-column prop='excludingTaxAmount' label='不含税价' align='center' />
                  <el-table-column prop='remark' label='说明' align='center' />
                </el-table>
              </div>
              <div class='paginationContainer' style='display: flex;align-items: center;padding: 10px 20px;'>
                <span>共{{ detailTotal3 }}条</span>
                <el-pagination background :page-sizes=' [10, 20, 30, 40] ' layout='sizes,prev, pager, next,jumper'
                               :total=' detailTotal3 ' @size-change=' detail3SizeChange ' @current-change=' detail3CurrentChange '
                               @prev-click=' detail3CurrentChange ' @next-click=' detail3CurrentChange ' />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label='开票信息' v-if=' detailData.status != 0 && detailData.status != 1 ' name='fourth'>
            <div class='baseInfo'>
              <!--              <div class='baseInfoContent' style='padding: 0'>
                              <div class='baseInfoContentItem'>
                                <span class='span1'>是否抵扣开票：</span>
                                <span>{{ detailData.time2 }}</span>
                              </div>
                              <div class='baseInfoContentItem'>
                                <span class='span1'>抵扣开票费用编号：</span>
                                <span>{{ detailData.time2 }}</span>
                              </div>
                              <div class='baseInfoContentItem specialItem'>
                                <div class='specialOne'>
                                  <span class='span1'>原开票金额：</span>
                                  <span>{{ detailData.customerNatureName }}</span>
                                </div>
                                <div>
                                  <span class='span1'>抵扣金额：</span>
                                  <span>{{ detailData.customerScaleName }}</span>
                                </div>
                              </div>
                            </div>-->
              <div class='operationTable' style='margin-top:0'>
                <el-table :data=' infoInvoice ' border script>
                  <el-table-column label='序号' align='center' type='index' />
                  <el-table-column prop='invoiceNo' label='发票号码' align='center' />
                  <el-table-column prop='invoiceCode' label='发票代码' align='center' />
                  <el-table-column prop='invoicDate' label='发票日期' align='center' />
                  <el-table-column prop='taxPrice' label='含税金额' align='center' />
                  <el-table-column prop='price' label='不含税金额' align='center' />
                  <el-table-column prop='taxRate' label='税率' align='center' />
                  <el-table-column prop='taxRate' label='开票类型' align='center'>
                    <template slot-scope='scope'>
                      {{ scope.row.invoiceType ? '补开票' : '正常开票' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop='remark' label='备注' align='center' />
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!--   详情对话框 end-->
    <!-- 核对对账单 start -->
    <el-dialog :title=' dialogTitle ' :visible.sync=' dialogVisible ' width='1200px' center @close=' dialogClose '
               :close-on-click-modal=' false '>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>委托商：</span>
              <span>{{ companyData.companyNameNew }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>标题：</span>
              <span>{{ companyData.title }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>合计含税费用：</span>
                <span>{{ companyData.settType === 1 ? companyData.taxPrice : companyData.taxSettPrice || 0
                  }}元</span>
              </div>
              <div>
                <span class='span1'>合计不含税费用：</span>
                <span>{{ companyData.settType === 1 ? companyData.noTaxPrice : companyData.noTaxSettPrice || 0
                  }}元</span>
              </div>
            </div>
            <el-tabs v-model=' activeName '>
              <el-tab-pane label='托运费用核对' name='first'>
                <div class='baseInfoContentItem'>
                  <span class='span1'>结算方式：</span>
                  <span>{{ companyData.settType === 1 ? '合同价' : '预结算价' }}</span>
                </div>
                <div class='baseInfoContentItem specialItem'>
                  <div class='specialOne'>
                    <span class='span1'>托运费合计含税费用：</span>
                    <span>{{ companyData.settlementPrice }}元</span>
                  </div>
                  <div>
                    <span class='span1'>托运费合计不含税费用：</span>
                    <span>{{ shippingFeeCalculation }}元</span>
                  </div>
                </div>
                <div class='baseInfoContentItem' style='display: flex'>
                  <span class='span1'>上传时间：</span>
                  <span>{{ companyData.time }}</span>
                  <span class='spanStyle' @click=' download '>下载</span>
                  <span class='spanStyle'>
                    <el-upload ref='upload' class='upload-demo' :disabled=' uploadDis ' :action=' uploadUrl '
                               :auto-upload=' true ' :show-file-list=' false ' :data=' uploadData ' :http-request=' uploadHttp '
                               :on-success=' planOnSuccess ' :before-upload=' beforeUpload '>重新上传
                    </el-upload>
                  </span>
                </div>
              </el-tab-pane>
              <el-tab-pane label='其它费用核对' name='second'>
                <div class='baseInfoContentItem specialItem'>
                  <div class='specialOne'>
                    <span class='span1'>其它费合计含税费用：</span>
                    <span>{{ companyData.otherPrice || 0 }}元</span>
                  </div>
                  <div>
                    <span class='span1'>其它费合计不含税费用：</span>
                    <span>
                      {{ (Number(sumCost(tableData2, 'excludingTaxAmount'))).toFixed(2) }}元
                    </span>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label='油价联动' name='oilPriceLinkage'>
                <div class='nav'>

                  <el-form :model=' oilPriceLinkageSearchForm ' label-width='110px' :inline=' true '
                           class='demo-form-inline flex1'>
                    <el-form-item label='运单编号：'>
                      <el-input v-model=' oilPriceLinkageSearchForm.waybillNo ' size='mini'
                                placeholder='请输入运单编号'></el-input>
                    </el-form-item>
                    <el-form-item label='车架号：'>
                      <el-input v-model=' oilPriceLinkageSearchForm.frameNumber ' size='mini' placeholder='请输入车架号'
                                @paste.native.capture.prevent=" (value) => { return searchCopyFormat(value, 'frameNumber') } "></el-input>
                    </el-form-item>
                    <el-form-item label='品牌：'>
                      <el-input v-model=' oilPriceLinkageSearchForm.brandName ' size='mini' placeholder='请输入品牌' />
                    </el-form-item>
                    <el-form-item label='运输方式：'>
                      <el-select v-model=' oilPriceLinkageSearchForm.transportationTerms ' filterable size='mini'
                                 placeholder='请选择运输方式'>
                        <el-option label='全部' value=''></el-option>
                        <el-option label='公路' value='1'></el-option>
                        <el-option label='水路' value='2'></el-option>
                        <el-option label='水陆联运' value='3'></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label='计划时间：'>
                      <el-date-picker v-model=' oilPriceLinkageSearchForm.planDates ' value-format='yyyy-MM-dd HH:mm:ss' type='daterange' align='right'
                                      size='mini' unlink-panels range-separator='-' start-placeholder='开始日期' end-placeholder='结束日期'
                                      :picker-options=' pickerOptions '>
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label='交车时间：'>
                      <el-date-picker v-model=' oilPriceLinkageSearchForm.deliveryDates ' value-format='yyyy-MM-dd HH:mm:ss' type='daterange' align='right'
                                      size='mini' unlink-panels range-separator='-' start-placeholder='开始日期' end-placeholder='结束日期'
                                      :picker-options=' pickerOptions '>
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item>
                      <el-button size='small' class='searchBtn' @click=' searchOilPriceLinkage '>查询
                      </el-button>
                      <el-button size='small' class='searchBtn' @click=' addOilPriceLinkage '>添加
                      </el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div class='content'>
                  <div class='tableContainer'>
                    <el-table ref='registerTable' v-loading=' tableLoading ' :data=' tableData ' style='width: 100%'
                              border :header-cell-style=' headerCellStyle ' @selection-change=' selectionChange '
                              max-height='350px'>
                      <el-table-column type='selection' align='center' min-width='80px' />
                      <el-table-column prop='waybillNo' label='运单编号' align='center' min-width='120px' />
                      <el-table-column prop='frameNumber' label='车架号' align='center' min-width='200px' />
                      <el-table-column prop='modelName' label='运输方式' align='center' min-width='100px' />
                      <el-table-column prop='brandName' label='品牌' align='center' min-width='100px' />
                      <el-table-column prop='departurePlace' label='起始地' align='center' min-width='180px' />
                      <el-table-column prop='arrivePlace' label='交车地' align='center' min-width='180px' />
                      <el-table-column prop='oilPrice' label='油价联动金额' align='center' min-width='180px' />
                    </el-table>
                  </div>
                </div>
                <div class='paginationContainer'>
                  <span>共{{ total2 }}条</span>
                  <el-pagination background :page-sizes=' [100, 500, 1000] ' layout='sizes,prev, pager, next,jumper' :total=' total2 '
                                 @size-change=' contractSizeChange2 ' @current-change=' contractCurrentChange2 '
                                 @prev-click=' contractCurrentChange2 ' @next-click=' contractCurrentChange2 ' />
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class='operation' v-if=" activeName === 'first' || activeName === 'second' ">
            <div class='operationTitle'>
              <div class='line' />
              <span>{{ activeName === 'first' ? '异常数据' : '已选择其它费用' }}</span>
            </div>
            <div class='operationTable' v-if=" activeName === 'first' ">
              <el-table :data=' tableData1 ' v-loading=' tableLoad1 ' :row-class-name=' tableRowClassName ' border script>
                <el-table-column label='序号' align='center' type='index' />
                <el-table-column prop='waybillNo' label='运单编号' align='center' show-overflow-tooltip />
                <el-table-column prop='frameNumber' label='车架号' align='center' show-overflow-tooltip />
                <el-table-column prop='taxRate' label='税率(%)' align='center' />
                <el-table-column prop='taxPrice' label='含税单价' align='center' />
                <el-table-column prop='neTaxPrice' label='不含税单价' align='center' />
                <el-table-column prop='type' label='异常类型' align='center'>
                  <template slot-scope='scope'>
                    {{ scope.row.type === 1 ? '数据未找到' : scope.row.type === 2 ? '未导入数据' : '价格异常' }}
                  </template>
                </el-table-column>
                <el-table-column label='运输方式' align='center' show-overflow-tooltip>
                  <template slot-scope='scope'>
                    {{ scope.row.transportationTerms === 1 ? '公路' : '水路' }}
                  </template>
                </el-table-column>
                <el-table-column prop='remark' label='说明' align='center' show-overflow-tooltip />
                <el-table-column label='操作' align='center' width='170'>
                  <template slot-scope='scope'>
                    <div v-if=' scope.row.type !== 1 '
                         style='display:flex;align-items:center;justify-content: center;padding: 5px;'>
                      <el-button size='mini' type='primary' @click=' changePriceClick(scope.$index, scope.row) '>修改金额
                      </el-button>
                      <el-button size='mini' type='danger' @click=' removeClick(scope.$index, scope.row, 0) '>
                        删除
                      </el-button>
                    </div>
                    <div v-else>--</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class='operationTable' v-else>
              <div class='operationTableNav'>
                <span @click=' exportClick '>添加</span>
              </div>
              <el-table :data=' tableData2 ' :row-class-name=' tableRowClassName ' border script>
                <el-table-column label='序号' align='center' type='index' />
                <el-table-column prop='costNum' label='费用编号' align='center' />
                <el-table-column prop='costTypeName' label='费用类型' align='center' />
                <el-table-column prop='costInstruction' label='费用说明' align='center' />
                <el-table-column prop='costTime' label='费用时间' align='center'>
                  <template slot-scope='scope'>{{ scope.row.costTime |formatTime }}</template>
                </el-table-column>
                <el-table-column prop='taxRate' label='税率(%)' align='center' />
                <el-table-column prop='costAmount' label='含税价' align='center' />
                <el-table-column prop='excludingTaxAmount' label='不含税价' align='center' />
                <el-table-column prop='remark' label='说明' align='center' />
                <el-table-column label='操作' align='center' width='50px'>
                  <div slot-scope='scope' style='display:flex;align-items:center;justify-content:center'
                       v-if=' tableData2.length && tableData2.length > 0 '>
                    <img alt='' :src=" require('@/assets/images/u725.png') "
                         :style=" 'width:22px;height:22px;cursor: pointer;' "
                         @click=' removeClick(scope.$index, scope.row, 1) ' />
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!--          <div class='operation'>
                      <div class='operationTitle'>
                        <div class='line' />
                        <span>{{ activeName === 'first' ? '未选择运单' : '未选择其它费用' }}</span>
                      </div>
                      <div class='operationTable' v-if="activeName==='first'">
                        <el-table
                          :data='tableData3'
                          :row-class-name='tableRowClassName'
                          border
                          script
                        >
                          <el-table-column label='序号' align='center' type='index' />
                          <el-table-column prop='waybill' label='运单编号' align='center' />
                          <el-table-column prop='batch' label='批次号' align='center' />
                          <el-table-column prop='chassis' label='底盘号' align='center' />
                          <el-table-column prop='brand' label='品牌' align='center' />
                          <el-table-column prop='model' label='型号' align='center' />
                          <el-table-column prop='type' label='费用类型' align='center' />
                          <el-table-column prop='rate' label='税率(%)' align='center' />
                          <el-table-column prop='price1' label='含税合同价' align='center' />
                          <el-table-column prop='price2' label='不含税合同价' align='center' />
                          <el-table-column prop='remark' label='说明' align='center' />
                          <el-table-column label='操作' align='center' width='170'>
                            <template slot-scope='scope'>
                              <div
                                style='display:flex;align-items:center;padding-left: 10px;justify-content: center;'>
                                <el-button size='mini' type='primary' @click='addTableClick(scope.$index, 0)'>
                                  添加
                                </el-button>
                                <el-button size='mini' type='primary'>首页提醒</el-button>
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                      <div class='operationTable' v-else>
                        <el-table
                          :data='tableData4'
                          :row-class-name='tableRowClassName'
                          border
                          script
                        >
                          <el-table-column label='序号' align='center' type='index' />
                          <el-table-column prop='waybill' label='运单编号' align='center' />
                          <el-table-column prop='batch' label='批次号' align='center' />
                          <el-table-column prop='chassis' label='底盘号' align='center' />
                          <el-table-column prop='brand' label='品牌' align='center' />
                          <el-table-column prop='model' label='型号' align='center' />
                          <el-table-column prop='type' label='费用类型' align='center' />
                          <el-table-column prop='rate' label='税率(%)' align='center' />
                          <el-table-column prop='price1' label='含税合同价' align='center' />
                          <el-table-column prop='price2' label='不含税合同价' align='center' />
                          <el-table-column prop='remark' label='说明' align='center' />
                          <el-table-column label='操作' align='center' width='75'>
                            <template slot-scope='scope'>
                              <div
                                style='display:flex;align-items:center;padding-left: 10px;justify-content: center;'>
                                <el-button size='mini' type='primary' @click='addTableClick(scope.$index, 1)'>
                                  添加
                                </el-button>
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>-->
        </div>
      </div>
    </el-dialog>
    <!-- 核对对账单 end -->
    <el-dialog title='选择适配车型' :visible.sync=' carVisible ' width='600px' @close=' carClose ' center
               :close-on-click-modal=' false ' top='20vh'>
      <div class='carContainer'>
        <div class='carContainerTitle'>
          <span>已选择车型：</span>
          <div class='carContainerTitleContent'>
            <div class='carContainerTitleContentItem' v-for='(  item, index  ) in   selectCar  ' @click=' selectRemove(item) '
                 :key=' index '>
              {{ item.name }}<i class='el-icon-close' />
            </div>
          </div>
        </div>
        <div class='carContainerTitle'>
          <span>选择品牌：</span>
          <div class='carContainerTitleContent'>
            <div class='carContainerTitleContentItem' v-for='  item   in   selectBrand  '>
              <p @click=' brandClick(item.id) '>{{ item.name }}&nbsp;</p><i class='el-icon-plus'
                                                                            @click=' brandAdd(item) ' />
            </div>
          </div>
        </div>
        <div class='carContainerTitle'>
          <span>选择型号：</span>
          <div class='carContainerTitleContent'>
            <div class='carContainerTitleContentItem' v-for='  item   in   selectModel  ' @click=' modelAdd(item) '>
              <p>{{ item.name }}</p><i class='el-icon-plus' />
            </div>
          </div>
        </div>
        <div class='btnContainer'>
          <el-button class='searchBtn' size='mini' @click=' carAddClick '>确定</el-button>
          <el-button class='resetBtn' size='mini' @click=' carClose '>关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title='添加其它费用' :visible.sync=' addVisible ' width='1000px' @close=' addClose ' center
               :close-on-click-modal=' false ' top='20vh'>
      <accounts-other-add ref='otherAdds' @closeDialog=' addClose ' @addOther=' getOtherData ' :account-id=' basicId '
                          :consignor-id=' companyData.companyId ' />
      <!--      <div class='addCost'>-->
      <!--        <div class='addCostNav'>-->
      <!--          <div class='navContainer' style='width: 230px'>-->
      <!--            <p>费用编号：</p>-->
      <!--            <el-input v-model='cost.Waybill' size='mini' style='width:150px'-->
      <!--                      placeholder='请输入费用编号' />-->
      <!--          </div>-->
      <!--          <div class='navContainer' style='width: 260px'>-->
      <!--            <p>费用类型：</p>-->
      <!--            <el-select v-model='cost.costType' filterable size='mini' placeholder='请输入运单编号'>-->
      <!--              <el-option v-for='item in costOptions' :key='item.value' :value='item.value'-->
      <!--                         :label='item.name'></el-option>-->
      <!--            </el-select>-->
      <!--          </div>-->
      <!--          <div class='navBtn'>-->
      <!--            <el-button size='small' class='searchBtn' @click='costSearch'>查询</el-button>-->
      <!--            <el-button size='small' class='resetBtn' @click='resetBtn2'>重置</el-button>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class='addCostTable'>-->
      <!--          <el-table-->
      <!--            ref='otherAddRef'-->
      <!--            :data='costTable'-->
      <!--            border-->
      <!--            script-->
      <!--            @select='handleSelectionChange'-->
      <!--            @select-all='selectAll'-->
      <!--            :reserve-selection='true'-->
      <!--            :row-key='bindRowKeys'-->
      <!--          >-->
      <!--            <el-table-column type='selection' align='center' width='70px'>-->
      <!--            </el-table-column>-->
      <!--            <el-table-column prop='costNum' label='费用编号' min-width='140' align='center' />-->
      <!--            <el-table-column prop='costTypeName' label='费用类型' align='center' />-->
      <!--            <el-table-column prop='costInstruction' label='费用说明' align='center' />-->
      <!--            <el-table-column prop='costTime' label='费用时间' min-width='140' align='center'>-->
      <!--              <template slot-scope='scope'>{{ scope.row.costTime|formatTime }}</template>-->
      <!--            </el-table-column>-->
      <!--            <el-table-column prop='taxRate' label='税率(%)' align='center' />-->
      <!--            <el-table-column prop='costAmount' label='含税价' align='center' />-->
      <!--            <el-table-column prop='excludingTaxAmount' label='不含税价' align='center' />-->
      <!--          </el-table>-->
      <!--        </div>-->
      <!--        <div class='paginationContainer'>-->
      <!--          <span>共{{ costTotal }}条</span>-->
      <!--          <el-pagination-->
      <!--            background-->
      <!--            :page-sizes='[10, 20, 30, 40]'-->
      <!--            layout='sizes,prev, pager, next,jumper'-->
      <!--            :total='costTotal'-->
      <!--            @size-change='contractSizeChange1'-->
      <!--            @current-change='contractCurrentChange1'-->
      <!--            @prev-click='contractCurrentChange1'-->
      <!--            @next-click='contractCurrentChange1'-->
      <!--            :current-page.sync='cost.page'-->
      <!--            :page-size='cost.rows'-->
      <!--          />-->
      <!--        </div>-->
      <!--      </div>-->
    </el-dialog>
    <el-dialog title='填写发票寄送方式' :visible.sync=' invoiceVisible ' width='600px' @close=' invoiceClose ' center
               :close-on-click-modal=' false '>
      <div class='depart'>
        <el-form :model=' invoiceData ' label-width='110px' :rules=' rules ' ref='ruleForm' size='medium'>
          <div-border label='开票选择' divStyle='margin-top: 10px'>
            <el-form-item label='发票寄送方式：' prop='type' style='margin-top: 15px;'>
              <el-radio v-model=' invoiceData.type ' :label=' 1 '>快递</el-radio>
              <el-radio v-model=' invoiceData.type ' :label=' 0 '>其它</el-radio>
            </el-form-item>
            <el-form-item v-if=' invoiceData.type === 1 ' label='快递类型：' prop='model'>
              <el-input :style=" 'width:100%' " v-model=' invoiceData.model ' placeholder='请输入快递类型' autocomplete='off'
                        size='mini' />
            </el-form-item>
            <el-form-item v-if=' invoiceData.type === 1 ' label='快递单号：' prop='num'>
              <el-input :style=" 'width:100%' " v-model=' invoiceData.num ' placeholder='请输入快递单号' autocomplete='off'
                        size='mini' />
            </el-form-item>
            <el-form-item label='寄送日期：' prop='date' style='margin-bottom: 20px;'>
              <el-date-picker v-model=' invoiceData.date ' type='date' value-format='yyyy-MM-dd' size='mini'
                              placeholder='选择寄送日期' />
            </el-form-item>
            <el-form-item label='备注：' prop='remark'>
              <el-input :style=" 'width:100%' " type='textarea' v-model=' invoiceData.remark ' placeholder='请输入备注'
                        autocomplete='off' size='mini' />
            </el-form-item>
          </div-border>
          <div class='btnContainer'>
            <el-button size='medium' class='searchBtn' :loading=' addLoad ' @click=' addClick '>确定
            </el-button>
            <el-button size='medium' class='resetBtn' @click=' invoiceClose '>关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog title='提交审核' :visible.sync=' auditVisible ' width='1300px' @close=' auditClose ' center
               :close-on-click-modal=' false '>
      <div class='depart'>
        <el-form :model=' auditData ' label-width='120px' :rules=' rules2 ' ref='ruleForm2' size='medium'>

          <div-border label='开票选择' divStyle='margin-top: 10px;padding-top:15px;'>
            <el-row>
              <el-col :span=' 12 '>
                <el-form-item label='购买方名称：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.purchaserName }}
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='销售方名称：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.sellerName }}
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='购买纳税人识别号：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.purchaserDentificaNumber }}
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='销售纳税人识别号：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.sellerDentificaNumber }}
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='购买方地址：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.purchaserAddress }}
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='销售方地址：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.sellerAddress }}
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='购买方电话：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.purchaserTel }}
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='销售方电话：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.sellerTel }}
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='购买方开户行：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.purchaserBankDeposit }}
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='销售方开户行：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.sellerBankDeposit }}
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='购买方银行账号：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.purchaserBankAccount }}
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='销售方银行账号：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.sellerBankAccount }}
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='是否开具销售清单：' label-width='150px' style='margin-bottom: 0' prop='type'>
                  <el-radio v-model=' isSalesList ' :label=' 0 '>否</el-radio>
                  <el-radio v-model=' isSalesList ' :label=' 1 '>是</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='交付方式：' label-width='150px' style='margin-bottom: 0'>
                  <el-select v-model=' auditDataSelectedValue.pushType ' filterable size='mini' style='width:188px'
                             placeholder='请选择状态'>
                    <el-option label='不交付' :value=' -1 ' />
                    <el-option label='邮箱交付' :value=' 0 ' />
                    <el-option label='手机交付' :value=' 1 ' />
                    <el-option label='邮箱、手机交付' :value=' 2 ' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='发票种类：' label-width='150px' style='margin-bottom: 0'>
                  <el-select v-model=' auditDataSelectedValue.invoiceLine ' filterable size='mini' style='width:188px'
                             placeholder='请选择状态'>
                    <el-option label='增值税专用发票' :value=' 0 ' />
                    <el-option label='增值税普通发票(纸票)' :value=' 2 ' />
                    <el-option label='机动车销售统一发票' :value=' 12 ' />
                    <el-option label='增值税普通发票(卷式)' :value=' 41 ' />
                    <el-option label='二手车销售统一发票' :value=' 42 ' />
                    <el-option label='增值税普通电子发票' :value=' 51 ' />
                    <el-option label='增值税专用电子发票' :value=' 52 ' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='开票类型：' label-width='150px' style='margin-bottom: 0'>
                  <el-select v-model=' auditDataSelectedValue.invoiceBlueOrRed ' filterable size='mini'
                             style='width:188px' placeholder='请选择状态'>
                    <el-option label='蓝字发票' :value=' 0 ' />
                    <el-option label='红字发票' :value=' 1 ' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span=' 12 ' v-if=' auditDataSelectedValue.invoiceBlueOrRed === 1 '>
                <el-form-item label='开具红票理由：' label-width='150px' style='margin-bottom: 0'>
                  <el-select v-model=' auditDataSelectedValue.blueRedReason ' filterable size='mini' style='width:188px'
                             placeholder='请选择状态'>
                    <el-option label='销货退回' :value=' 1 ' />
                    <el-option label='开票有误' :value=' 2 ' />
                    <el-option label='服务中止' :value=' 3 ' />
                    <el-option label='销售折让' :value=' 4 ' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='发票标识：' label-width='150px' style='margin-bottom: 0'>
                  <el-select v-model=' auditDataSelectedValue.invoiceFlag ' filterable size='mini' style='width:188px'
                             placeholder='请选择状态'>
                    <el-option label='普通发票' :value=' 0 ' />
                    <el-option label='成品油发票' :value=' 1 ' />
                    <el-option label='收购发票' :value=' 2 ' />
                    <el-option label='机动车发票' :value=' 3 ' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='代开标志：' label-width='150px' style='margin-bottom: 0'>
                  <el-select v-model=' auditDataSelectedValue.proxyInvoiceFlag ' filterable size='mini'
                             style='width:188px' placeholder='请选择状态'>
                    <el-option label='非代开' :value=' 0 ' />
                    <el-option label='代开' :value=' 1 ' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span=' 12 '>
                <el-form-item label='纳税原因说明：' label-width='150px' style='margin-bottom: 0'>
                  <el-select v-model=' auditDataSelectedValue.specialTaxRateReason ' filterable size='mini'
                             style='width:188px' placeholder='请选择状态'>
                    <el-option label='无理由' :value=' 0 ' />
                    <el-option label='政策出台前发生纳税义务' :value=' 1 ' />
                    <el-option label='前期已开具相应征收率发票，发生销售折让、中止或者退回等情形需要开具红字发票，或者开票有误需要重新开具' :value=' 2 ' />
                    <el-option label='因为实际经营业务需要，放弃享受免征增值税政策' :value=' 3 ' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span=' 24 '>
                <el-form-item label='发票备注：' label-width='150px' style='margin-bottom: 0'>
                  <el-input type='textarea' v-model=' auditDataSelectedValue.invoiceRemark ' :rows=' 3 '
                            placeholder='请输入发票备注' style='width: 83%;' />
                </el-form-item>
              </el-col>
            </el-row>

            <div>
              <el-row type='flex' justify='space-between' align='middle' style='margin-bottom: 10px;'>
                <el-col :span=' 12 '>
                  <el-button type='primary' @click=' addInvoice '>添加</el-button>
                </el-col>
                <el-col :span=' 12 '>
                  <div style='float: right'>
                    结算数量：{{ auditData.settlementNum }}
                    剩余未结算数量：{{ settlementQuantityCalculation }}
                    其他数量：{{ auditData.otherNum }}
                    剩余其他未结算数量：{{ otherNumCalculation }}
                  </div>
                </el-col>
              </el-row>
              <div class='tableContainer'>
                <el-table :data=' invoiceTableData ' style='width: 100%;margin-bottom: 10px;' border stripe
                          :header-cell-style=' headerCellStyle ' :cell-style=' cellStyle '>
                  <el-table-column label='序号' align='center' type='index' />
                  <el-table-column width='160px' label='服务名称' prop='serviceName' align='center' show-overflow-tooltip />
                  <el-table-column width='200px' label='规格型号' prop='specificaModel' align='center'
                                   show-overflow-tooltip />
                  <el-table-column label='结算数量' prop='settlementNum' align='center' show-overflow-tooltip />
                  <el-table-column width='120p' label='其它结算数量' prop='otherNum' align='center' show-overflow-tooltip />
                  <el-table-column width='150px' label='不含税金额' prop='price' align='center' show-overflow-tooltip />
                  <el-table-column label='税率(%)' prop='taxRate' align='center' show-overflow-tooltip />
                  <el-table-column label='含税金额' prop='taxPrice' align='center' show-overflow-tooltip />
                  <el-table-column width='200px' label='是否抵扣开票' align='center' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      {{ scope.row.isDeduct ? '是' : '否' }}
                    </template>
                  </el-table-column>
                  <el-table-column width='200px' label='是否抵扣超出合同价对账单' align='center' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      {{ scope.row.isDeductionPrice ? '是' : '否' }}
                    </template>
                  </el-table-column>
                  <el-table-column width='200px' label='是否暂缓开票' prop='se' align='center' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      {{ scope.row.isSuspendBilling ? '是' : '否' }}
                    </template>
                  </el-table-column>
                  <el-table-column width='200px' label='操作' align='center' fixed='right'>
                    <template slot-scope='scope'>
                      <el-button type='warning' size='small' @click=' editTableClick(scope.row.id) '>编辑
                      </el-button>
                      <el-button type='danger' size='small' @click=' deleteTableClick(scope.row.id) '>
                        删除
                      </el-button>

                    </template>
                  </el-table-column>
                </el-table>
                <div style='padding-bottom: 8px;display: flex;justify-content: flex-end;'
                     v-if=' invoiceTableData && invoiceTableData.length > 0 '>
                  开票合计含税金额：{{ invoiceTableData[0].taxTotalPrice }}
                  开票合计不含税金额：{{ invoiceTableData[0].totalprice }}
                </div>
              </div>
            </div>
          </div-border>
          <div class='btnContainer'>
            <el-button size='medium' class='searchBtn' @click=' auditConfirmClick ' :loading=' submitLoading '
            >
              确定
            </el-button>
            <el-button size='medium' class='resetBtn' @click=' auditClose '>关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <!-- 创建发票 -->
    <el-dialog title='创建发票' :visible.sync=' addInvoiceVisible ' width='950px' @close=' addInvoiceClose ' center
               :close-on-click-modal=' false '>
      <div class='depart'>
        <add-shipping-invoice ref='addInvoice' @addInvoiceClose=' addInvoiceClose ' />
      </div>
    </el-dialog>

    <!-- 推送 -->
    <el-dialog title="选择推送" :visible.sync="dialogFormVisiblePush">
      <el-form :model="formPush" :inline="true">
        <el-form-item label="商品编号" label-width="120px">
          <el-select v-model="formPush.classbName" placeholder="请选择商品编号">
            <el-option :label="item.classaName" :value="item.classbName" v-for="(item, index) in productNumberOption" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发票类型" label-width="120px">
          <el-select v-model="formPush.invoiceType" placeholder="请选择发票类型">
            <el-option :label="item.classaName" :value="item.classbName" v-for="(item, index) in invoiceTypeOption" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" label-width="120px">
          <el-input type="textarea" v-model="formPush.remarks" placeholder="请输入发票备注" style="width: 460px" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisiblePush = false">取 消</el-button>
        <el-button type="primary" :loading="pushLoading" @click="surePush">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 填写发票 -->
    <invoice-information ref='invoiceInformation' />
    <!-- 添加合同价 -->
    <add-contract-price ref='addContractPrice' @getList=' accountList ' />
    <!-- 添加油价联动 -->
    <add-oil-price-linkage-form ref='addOilPriceLinkageFormRef' @clearCheckData=' clearCheckData ' />
    <!-- 提交开票 -->
    <submit-billing ref='submitBillingRef' @submitBilling=' submitBilling ' />
  </div>
</template>

<script>
import steps from '@/components/steps.vue';
import divBorder from '@/components/divBorder.vue';
import invoiceInformation from '@/components/invoiceInformation';
import { formatDateTime, formatTime, getSessionStore } from '@/config/mUtils';
import {
  accountList,
  AccountDetail,
  accountDelete,
  getInvoiceInfo,
  getInvoiceList,
  infoInvoice,
  deleteInvoice,
  submitAuditInvoice,
  getPageListSCFI,
  getPageListSOCI,
  othercostGetAllByCompanyId,
  updateAndDeleteAmount,
  cancelApplyFor,
  delOther,
  accountDetail,
  getInfoInvoice,
  oilPriceLinkageQuery,
  changeTitle,
  oilPriceLinkQueryByRsi, cancellation, dataPush, remarkSubmit, hongChong,repeal
} from '@/service/getData';
import AddShippingInvoice from '../components/addShippingInvoice.vue';
import { getImport } from '@/service/getIP';
import accountsOtherAdd from '@/views/settle/supplier/components/accountsOtherAdd';
import AddContractPrice from '@/components/addContractPrice';
import { baseUrl } from '@/config/env';
import AddOilPriceLinkageForm from '@/views/settle/client/components/shippingCharges/addOilPriceLinkageForm';
import { incomeSubmitInvoiceAdd } from '@/service/financial';
import SubmitBilling from '@/components/submitBilling';
import {push} from "echarts/lib/component/dataZoom/history";
import PortCharges from "@/views/settle/client/portCharges.vue";
import RegularCarReimbursementStatement from "@/views/settle/client/components/regularCarReimbursementStatement.vue";
import { paramCategoryPageList } from '@/service/basicfile';

export default {
  components: {
    RegularCarReimbursementStatement,
    PortCharges,
    SubmitBilling,
    AddOilPriceLinkageForm,
    AddContractPrice,
    accountsOtherAdd,
    steps,
    divBorder,
    AddShippingInvoice,
    invoiceInformation,
  },
  data() {
    return {
      activeRow: null,
      productNumberOption: [],
      invoiceTypeOption: [],
      formPush: {
        classbName: '',
        invoiceType: '',
        remarks: ''
      },
      dialogFormVisiblePush: false,
      pushLoading: false,
      msg: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          },
        }],
      },
      submitLoading: false,
      id:'',
      oilPriceLinkageSearchForm: {
        waybillNo: '',
        frameNumber: '',
        brandName: '',
        transportationTerms: '',
        planDates: ['', ''],
        deliveryDates: ['', ''],
        page: 1,
        rows: 10,
      },
      defaultSearchForm: {},
      searchForm: {
        type: 22,
        settNo: '',
        title: '',
        companyName: '',
        reconciliator: '',
        startTime: '',
        endTime: '',
        settType: '',
        status: '',
        page: 1,
        rows: 10,
      },
      tableData: [],
      tableLoading: false,
      activeName: 'first',
      activeName1: 'first',
      stateOption: [
        {
          value: '',
          label: '全部',
        },
        {
          value: 0,
          label: '待提交审核',
        },
        {
          value: 1,
          label: '审核对账单中',
        },
        {
          value: 2,
          label: '系统开票中',
        },
        {
          value: 3,
          label: '填写快递单号',
        },
        {
          value: 4,
          label: '已收款',
        },
        {
          value: -1,
          label: '审核未通过',
        },
        {
          value: -2,
          label: '系统开票失败',
        },
        {
          value: -10,
          label: '已取消',
        },
      ],
      typeOption: [
        {
          label: '合同价',
          value: '1',
        },
        {
          label: '预结算价',
          value: '2',
        },
        {
          label: '合并价格',
          value: '3',
        },
      ],
      page: 1,
      size: 10,
      total: 0,
      total2: 0,
      tableLoad: false,
      tableLoad1: false,
      TableDatas: [],
      detailDialogVisible: false,
      detailDialogWidth: '1050px',
      addLoad: false,
      detailTable: [],
      detailTotal: 0,
      detailSize: 10,
      detailPage: 1,
      detailTable2: [],
      detailTotal2: 0,
      detailSize2: 10,
      detailPage2: 1,
      detailTable3: [],
      detailTotal3: 0,
      detailSize3: 10,
      detailPage3: 1,
      detailData: {},
      operationData: [],
      dialogVisible: false,
      dialogTitle: '',
      nameOption: [],
      payOption: [],
      addressOption: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      companyData: {},
      invoiceData: {},
      rules: {
        num: [
          {
            required: true,
            message: '请输入快递单号',
            trigger: 'blur',
          },
        ],
        date: [
          {
            required: true,
            message: '请选择寄送日期',
            trigger: 'change',
          },
        ],
        model: [
          {
            required: true,
            message: '请输入快递类型',
            trigger: 'blur',
          },
        ],
        type: [
          {
            required: true,
            message: '请选择发票寄送方式',
            trigger: 'change',
          },
        ],
      },
      carVisible: false,
      selectedCar: [],
      selectCar: [],
      brands: [],
      models: [],
      brands2: [],
      models2: [],
      selectBrand: [],
      selectModel: [],
      allCar: [],
      allModel: [],
      expands: [],
      addVisible: false,
      cost: {
        Waybill: '',
        costType: '',
        page: 1,
        rows: 10,
      },
      costTable: [],
      selectCostTable: [],
      costTotal: 0,
      costSize: 0,
      costPage: 0,
      invoiceVisible: false,
      auditVisible: false,
      auditData: {},
      defaultAuditDataSelectedValue: {},
      auditDataSelectedValue: {
        pushType: -1,
        invoiceLine: 0,
        invoiceBlueOrRed: 0,
        invoiceFlag: 0,
        proxyInvoiceFlag: 0,
        specialTaxRateReason: 0,
      },
      rules2: {
        isSalesList: [
          {
            required: true,
            message: '请选择是否开具销售清单',
            trigger: 'change',
          },
        ],
      },
      stepData: [],
      headerCellStyle: {
        color: '#3B3B3B',
        'font-size': '13px',
        height: '48px',
        background: '#E8E8E8',
      },
      cellStyle: {
        color: '#7F7F7F',
        'font-size': '13px',
        height: '52px',
      },
      invoiceTableData: [], // 发票数据
      addInvoiceVisible: false,
      isSalesList: 0, // 是否开具销售清单,
      basicId: 0,
      settlementNum: 0, // 未结算数量
      otherNum: 0, // 其他未结算数量
      settlement: 1, // 结算方式 1：合同价 2：预结算价
      uploadDis: false, // 批量导入状态
      uploadUrl: '', // 托运费用核对导入
      // 托运费用核对导入
      uploadData: {
        mFile: '',// 托运费用核对导入
      },
      companyId: '',// 公司 id
      purchaserId: '',// 委托商 id
      costOptions: [{
        name: '全部',
        value: '',
      }],
      infoInvoice: [], // 详情 开票信息
      checkData: [], // 油价联动选中数据
      checkTableData: [], // 列表选中数据
      invoicingLoading: false,
    };
  },
  watch: {
    activeName(val) {
      if (val === 'oilPriceLinkage') {
        // this.searchOilPriceLinkage();
      }
    },
    activeName1(val) {
      if (val === 'second') {
        this.getPageListSCFI();
      } else if (val === 'third') {
        this.getPageListSOCI();
      }
    },
  },
  computed: {
    stepState() {
      return function (state) {
        switch (state) {
          case '':
            return 'wait';
          case 'success':
            return 'success';
          case 'failure':
            return 'error';
        }
      };
    },
    getState(state) {
      return function (state) {
        switch (state) {
          case 0:
            return '待提交审核';
          case 1:
            return '审核对账单中';
          case 2:
            return '待提交开票';
          case 3:
            return '开票中';
          case 4:
            return '已开票';
          case 6:
            return '待财务审核';
          case -1:
            return '审核未通过';
          case -2:
            return '系统开票失败';
          case -10:
            return '已取消';
        }
      };
    },
    getTime() {
      return function (time) {
        return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
      };
    },
    /**
     *计算合计
     * @param tableData 表格数据
     * @param field 字段名
     * @returns {function(*, *): number}
     */
    sumCost(tableData, field) {
      return function (tableData, field) {
        let sum = 0;
        tableData ? tableData.forEach((item) => {
          sum += parseFloat(item[field]);
        }) : 0;
        return sum;
      };
    },
    settlementQuantityCalculation() {
      let returnStr = this.auditData.settlementNum;
      this.invoiceTableData.forEach(res => {
        if (res.settlementNum) {
          returnStr -= res.settlementNum;
        }
      });
      this.settlementNum = returnStr;
      return returnStr;
    },
    otherNumCalculation() {
      let returnStr = this.auditData.otherNum;
      this.invoiceTableData.forEach(res => {
        if (res.otherNum) {
          returnStr -= res.otherNum;
        }
      });
      this.otherNum = returnStr;
      return returnStr;
    },
    shippingFeeCalculation() {
      return this.companyData.settlementPrice ? (this.companyData.settlementPrice - (this.companyData.settlementPrice * this.companyData.taxRate / 100)).toFixed(2) : 0;
    },
    otherFeeCalculation() {
      console.log(this.companyData.otherPrice ? (this.companyData.otherPrice - (this.companyData.otherPrice * this.companyData.taxRate / 100)).toFixed(2) : 0);
      return this.companyData.otherPrice ? (this.companyData.otherPrice - (this.companyData.otherPrice * this.companyData.taxRate / 100)).toFixed(2) : 0;
    },
  },
  mounted() {
    this.defaultAuditDataSelectedValue = JSON.parse(JSON.stringify(this.auditDataSelectedValue));
    this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
    // this.accountList();
    this.uploadUrl = getImport('/platform/customer/account/checkAccountStatement');
  },
  filters: {
    formatTime(val) {
      if (val) {
        return formatTime(val, 'yyyy-mm-dd hh:ii:ss');
      } else {
        return '';
      }
    },
  },
  methods: {
    async onClickVoid(row) {
      const { status, message, data } = await repeal({id: row.id});
      if (status !== 0) return this.$message.warning(message);
      this.$message.success(message);
      this.accountList();
    },
    async hongChong(row) {
      // console.log(row.id);
      this.$confirm('是否生成红冲对账单', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const msg = this.$message({
          // showClose: true,
          iconClass: 'el-icon-loading',
          message: '生成红冲对账单中......'
        });
        const { status, message } = await hongChong({id: row.id});
        if (status !== 0) return this.$message.warning(message);
        msg.close()
        this.$message.success(message);
        this.searchBtn();
      })

    },
    async surePush() {
      this.pushLoading = true
      // let flag = true;
      // Object.keys(this.formPush).forEach((key) => {
      //   if (!this.formPush[key]) flag = false;
      // });
      // if (flag) {
        const params ={
          classbName: this.formPush.classbName,
          invoiceType: this.formPush.invoiceType,
          remarks: this.formPush.remarks,
          id:this.activeRow.id,
          reconciliator: this.activeRow.reconciliator
        }
        const { status, message } = await dataPush(params);
        this.pushLoading = false
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        await this.accountList();
        this.dialogFormVisiblePush = false
      // }

    },
    editRemark(row) {
      this.$prompt('备注', '更改备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        inputValue: row.remark
      })
        .then(async ({ value }) => {
          const { status, message } = await remarkSubmit({
            id: row.id,
            remark: value
          });
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.searchBtn();
        })
    },
    //获取发票号
    getInvoiceNo(row){
      if(row.invoiceManageList !== null){
        return row.invoiceManageList.map(item =>item.invoiceNo).join(',')
      }else {
        return ''
      }
    },
    //获取发票时间
    getInvoiceCreateTime(row){
      if(row.invoiceManageList !== null){
        return row.invoiceManageList.map(item =>item.createTime).join(',')
      }else {
        return ''
      }
    },
    //获取发票金额
    getInvoicePrice(row){
      if(row.invoiceManageList !== null){
        return row.invoiceManageList.map(item =>item.taxPrice).join(',')
      }else {
        return ''
      }
    },
    settTypeFormat(r, c, cellValue) {
      switch (cellValue) {
        case 1:
          return '合同价';
        case 2:
          return '预结算价';
        case 3:
          return '合并价格';
      }
    },
    async printInvoice(id) {
      const {
        status,
        message,
        data,
      } = await getInvoiceList(id);
      if (status !== 0) return this.$message.warning(message);
      this.$message.success(message);
      const a = document.createElement('a');
      a.href = `2,${data.id}`;
      a.click();
    },
    async getInvoiceList(id) {
      const {
        data,
        status,
        message,
      } = await getInvoiceList(id);
      if (status === 0) {
        this.invoiceTableData = data;
      } else {
        this.$message.warning(message);
      }
    },
    async accountList() {
      this.tableLoad = true;
      const res = await accountList(this.searchForm);
      this.tableLoad = false;
      if (res.status !== 0) return this.$message.warning(res.methods);
      this.total = res.data.total;
      this.TableDatas = res.data.records;
      this.msg = res.msg;
    },
    compareDate(d1, d2) {
      return ((new Date(d1.replace(/-/g, '\/'))) > (new Date(d2.replace(/-/g, '\/'))));
    },
    // 结束时间
    dateChange(val) {
      if (this.searchForm.endTime && this.searchForm.startTime && this.compareDate(this.searchForm.startTime, this.searchForm.endTime)) {
        if (val === this.searchForm.endTime) this.searchForm.endTime = '';
        if (val === this.searchForm.startTime) this.searchForm.startTime = '';
        this.$forceUpdate();
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
    // 结算费用条数
    detailSizeChange(size) {
      this.detailSize = size;
      this.getPageListSCFI();
    },
    // 结算费用页数
    detailCurrentChange(page) {
      this.detailPage = page;
      this.getPageListSCFI();
    },
    // 其他结算费用条数
    detail3SizeChange(size) {
      this.detailSize3 = size;
      this.getPageListSOCI();
    },
    // 其他结算费用页数
    detail3CurrentChange(page) {
      this.detailPage3 = page;
      this.getPageListSOCI();
    },
    // 主页面条数
    contractSizeChange(sizes) {
      this.searchForm.rows = sizes;
      this.accountList();
    },
    contractSizeChange1(sizes) {
      this.cost.rows = sizes;
      this._othercostGetAllByCompanyId();
    },
    // 油价联动
    contractSizeChange2(sizes) {
      this.oilPriceLinkageSearchForm.rows = sizes;
      this.searchOilPriceLinkage();
    },
    // 主页面页数
    contractCurrentChange(page) {
      this.searchForm.page = page;
      this.accountList();
    },
    contractCurrentChange1(page) {
      this.cost.page = page;
      this._othercostGetAllByCompanyId();
    },
    // 主页面页数
    contractCurrentChange2(page) {
      this.oilPriceLinkageSearchForm.page = page;
      this.searchOilPriceLinkage();
    },
    detailClose() {
      this.detailDialogVisible = false;
      this.activeName1 = 'first';
    },
    dialogClose() {
      this.dialogVisible = false;
      this.tableData1 = [];
      this.tableData2 = [];
      this.activeName = 'first';
      this.accountList();
    },
    addClick() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.addLoad = true;
          this.addLoad = false;

          this.invoiceVisible = false;
        } else {
          return false;
        }
      });
    },
    nameChange() {
    },
    carClick() {
      this.carVisible = true;
      this.selectCar = [...this.selectedCar];
      this.brands = [...this.brands2];
      this.models = [...this.models2];
    },
    selectRemove(item) {
      this.selectCar.splice(this.selectCar.indexOf(item), 1);
      if (this.brands.indexOf(item) !== -1) {
        this.brands.splice(this.brands.indexOf(item), 1);
      } else {
        this.models.splice(this.models.indexOf(item), 1);
      }
    },
    brandAdd(item) {
      if (this.selectCar.indexOf(item) !== -1) return this.$message.warning('已选择该品牌！');
      let arr = [];
      for (let i = 0; i < this.allCar.length; i++) {
        if (this.allCar[i].id === item.id) {
          arr = this.allCar[i].carModel;
          break;
        }
      }
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < this.selectCar.length; j++) {
          if (arr[i].id === this.selectCar[j].id) {
            this.selectCar.splice(j, 1);
            j--;
          }
        }
      }
      this.selectCar.push(item);
      this.brands.push(item);
    },
    async addClose() {
      this.addVisible = false;
    },
    modelAdd(item) {
      for (let i = 0; i < this.selectCar.length; i++) {
        if (this.selectCar[i].id === item.brandId) {
          return this.$message.warning('上方已选择该品牌的全部车型！');
        }
        if (this.selectCar[i].id === item.id) return this.$message.warning('已选择该车型！');
      }
      this.selectCar.push(item);
      this.models.push(item);
    },
    carAddClick() {
      this.carVisible = false;
      this.selectedCar = [...this.selectCar];
      this.brands2 = [...this.brands];
      this.models2 = [...this.models];
    },
    tableRowClassName({ row }) {
      if (row.price1 !== row.price2) {
        return 'ui-warning-row';
      }
      return '';
    },
    exportClick() {
      this.addVisible = true;
      // 调用子组件 分页查询
      this.$nextTick(() => {
        this.$refs.otherAdds._othercostGetAllByCompanyId();
      });
    },
    removeClick(index, val, type) {
      this.$confirm('确定要删除当前数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          if (type) {
            const {
              status,
              message,
            } = await delOther({
              accountId: this.basicId,
              otherCostId: val.id,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.getOtherData();
          } else {
            const obj = {
              ...val,
              flag: 22,
              operateType: 'delete',
            };
            const res = await updateAndDeleteAmount(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.tableData1.splice(index, 1);
            const { data } = await accountDetail(this.basicId);
            this.companyData = data;
          }
        })
        .catch(() => {
        });
      // if (val) {
      //   this.tableData4.push(this.tableData2.splice(index, 1)[0]);
      // } else {
      //   this.tableData3.push(this.tableData1.splice(index, 1)[0]);
      // }
    },
    addTableClick(index, val) {
      if (val) {
        this.tableData2.push(this.tableData4[index]);
        this.tableData4.splice(index, 1);
      } else {
        this.tableData1.push(this.tableData3[index]);
        this.tableData3.splice(index, 1);
      }
    },
    resetBtn2() {
      this.cost = {
        Waybill: '',
        costType: '',
        page: 1,
        rows: 10,
      };
    },
    costSearch() {
      this.cost.page = 1;
      this._othercostGetAllByCompanyId();
    },
    //  分页查询
    async _othercostGetAllByCompanyId() {
      let {
        Waybill,
        costType,
      } = this.cost;
      let obj = {
        companyId: this.companyId,
        costNum: Waybill,
        costTypeId: costType,
      };
      this.tableLoad = true;
      let res = await othercostGetAllByCompanyId(obj);
      this.tableLoad = false;
      if (res.status !== 0) return this.$message.error(res.message);
      this.costTotal = res.data.total;
      this.costTable = res.data.records;
      //因为重新请求了数据，重新回显
      this.toggleSelection();

    },
    // 父组件调动函数 父组件子组件多选表格联动 重新勾选
    toggleSelection() {
      //清空勾选
      this.$refs.otherAddRef.clearSelection();
      this.$nextTick(() => {
        //将数据循环筛选
        //tableData2  父组件传入数据  id相同就勾选
        if (this.tableData2) {
          this.tableData2.forEach((value, index) => {
            this.$refs.otherAddRef.toggleRowSelection(this.costTable.find(item => {
              return value.id === item.id;
            }));
          });
        }
      });

    },
    changePriceClick(index, val) {
      const numReg = new RegExp(/^\d+(\.\d+)?$/);
      this.$prompt('请输入修改金额', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '请输入修改金额',
        inputValidator: (value) => {
          if (!value) return '请输入修改金额';
          if (!numReg.test(value)) return '请输入修改金额（仅非负数字）';
        },
        beforeClose: async (action, instance, done) => {
          if (action === 'cancel') {
            done();
            return;
          }
          val.taxPrice = instance.inputValue;
          let obj = {
            ...val,
            flag: 22,
            operateType: 'update',
          };
          const {
            status,
            message,
          } = await updateAndDeleteAmount(obj);
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          const { data } = await accountDetail(this.basicId);
          this.companyData = data;
          done();
        },
      });
    },
    handleSelectionChange(val) {
      this.selectCostTable = val;
    },
    selectAll(val) {
      this.selectCostTable = val;
    },
    carClose() {
      this.carVisible = false;
    },
    brandClick(id) {
      for (let i = 0; i < this.allCar.length; i++) {
        if (this.allCar[i].id === id) {
          this.selectModel = this.allCar[i].carModel.map(item => ({
            id: item.id,
            name: item.brand_name,
            brandId: item.brand_id,
          }));
          break;
        }
      }
    },
    deleteClick(id,reconciliator) {
      this.$confirm('确认删除当前对账单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const {
            status,
            message,
          } = await accountDelete(id,reconciliator);
          if (status === 0) {
            this.$message.success(message);
            this.searchBtn();
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
        });
    },
    async editTableClick(id) {
      const {
        data,
        status,
        message,
      } = await infoInvoice(id);
      if (status !== 0) return this.$message.warning(message);
      this.addInvoiceVisible = true;
      this.$nextTick(() => {
        this.$refs.addInvoice.invoiceData = data;
        this.$refs.addInvoice.settlementNum = this.settlementNum + data.settlementNum;
        this.$refs.addInvoice.otherNum = this.otherNum;
        this.$refs.addInvoice.addOrEdit = 'edit';
        this.$refs.addInvoice.getServiceName();
        this.$refs.addInvoice.getSelection(this.purchaserId);
      });
    },
    deleteTableClick(id) {
      this.$confirm('确认删除当前发票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await deleteInvoice(id);
          if (res.status === 0) {
            this.$message.success(res.message);
            await this.getInvoiceList(this.basicId);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
        });
      this.invoiceTableData.splice(index, 1);
    },
    hiddenClick(index, row) {
      this.TableDatas[index].tableShow = !this.TableDatas[index].tableShow;
      Array.prototype.remove = function (val) {
        const index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      if (this.expands.indexOf(row.id) < 0) {
        this.expands.push(row.id);
      } else {
        this.expands.remove(row.id);
      }
    },
    disableClick(id,reconciliator) {
      this.$confirm('确认要取消审核申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const {
            status,
            message,
          } = await cancelApplyFor(id,reconciliator);
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          await this.accountList();
        })
        .catch(() => {
        });
    },
    async detailClick(id) {
      const {
        status,
        data,
        message,
      } = await AccountDetail(id);
      if (status !== 0) this.$message.warning(message);
      this.basicId = id;
      this.detailDialogVisible = true;
      this.settlement = data.settType;
      this.detailData = data;
      this.operationData = data.operateRecordList;
      if (data.auditRecordList) {
        this.stepData = [];
        // 审核信息数据
        data.auditRecordList.forEach(res => {
          const str = this.strFormat(res.status);
          const state = res.status == 3 ? 'failure' : res.status == 2 ? 'success' : '';
          this.stepData.push({
            title: res.auditorName + str,
            time: res.createTime,
            state,
            remark: res.opinion,
          });
        });
      }
      await this.getInfoInvoice(id);
    },
    async getInfoInvoice(id) {
      const {
        status,
        data,
        message,
      } = await getInfoInvoice(id);
      if (status !== 0) return this.$message.warning(message);
      this.infoInvoice = data;
    },
    addInvoice() {
      this.addInvoiceVisible = true;
      this.id = this.auditData.id
      this.$nextTick(() => {
        this.$refs.addInvoice.invoiceData.basicId = this.id;
        this.$refs.addInvoice.settlementNum = this.settlementNum;
        this.$refs.addInvoice.otherNum = this.otherNum;
        this.$refs.addInvoice.addOrEdit = 'add';
        this.$refs.addInvoice.getServiceName();
        this.$refs.addInvoice.getSelection(this.purchaserId);
        // this.$refs.addInvoice.settlementNum = this.settlementQuantityCalculation()
      });
    },
    addInvoiceClose(type) {
      if (type === 'confirm') {
        this.getInvoiceList(this.basicId);
      }
      this.addInvoiceVisible = false;
      // this.$refs.ruleForm.resetFields();
    },
    invoiceClose() {
      this.invoiceVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    invoiceClick() {
      this.invoiceVisible = true;
      this.invoiceData = {
        type: 22,
      };
    },
    async changeClick(id) {
      this.id=id;
      const {
        status,
        data,
        message,
      } = await AccountDetail(id);
      if (status !== 0) return this.$message.warning(message);
      this.basicId = id;
      this.companyId = data.companyId;
      this.dialogTitle = '核对对账单';
      this.dialogVisible = true;
      this.settlement = data.settType;
      this.companyData = data;
      await this.getOtherData()
    },
    searchBtn() {
      this.page = 1;
      this.accountList();
    },
    bindRowKeys(row) {
      return row.id;
    },
    resetBtn() {
      this.searchForm.settNo = '';
      this.searchForm.startTime = '';
      this.searchForm.endTime = '';
      this.searchForm.settType = '';
      this.searchForm.companyName = '';
      this.searchForm.status = '';
      this.searchForm.reconciliator = '';
    },
    async auditClick(id,reconciliator) {
      this.auditDataSelectedValue = JSON.parse(JSON.stringify(this.defaultAuditDataSelectedValue));
      const {
        status,
        data,
        message,
      } = await getInvoiceInfo(id);
      if (status !== 0) return this.$message.error(message);
      this.auditData = data;
      this.auditData.id = id
      this.reconciliator = reconciliator
      this.purchaserId = data.purchaserId;
      this.auditVisible = true;
      this.$nextTick(() => {
        this.getInvoiceList(id);
      });
    },
    auditClose() {
      this.auditVisible = false;
      this.$refs.ruleForm2.resetFields();
    },
    auditConfirmClick() {
      this.auditData.isSalesList = this.isSalesList;
      this.$refs.ruleForm2.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          const {
            status,
            message,
          } = await submitAuditInvoice({
            id: this.auditData.id,
            isDetailedList: this.isSalesList,
            type: this.searchForm.type,
            reconciliator: this.reconciliator,
            ...this.auditDataSelectedValue,
          });
          this.submitLoading = false;
          if (status === 0) {
            this.$message.success(message);
            this.auditVisible = false;
            this.$refs.ruleForm2.resetFields();
            await this.accountList();
          } else {
            this.$message.warning(message);
          }
        } else {
          return false;
        }
      });
    },
    // 格式化审核信息状态
    strFormat(val) {
      let returnStr = '';
      switch (val) {
        case 0:
          returnStr = ' 重新发起';
          break;
        case 1:
          returnStr = ' 发起';
          break;
        case 2:
          returnStr = ' 同意';
          break;
        case 3:
          returnStr = ' 拒绝';
          break;
        case 4:
          returnStr = ' 取消审核';
          break;
        default:
          returnStr = '';
          break;
      }
      return returnStr;
    },
    async getPageListSCFI() {
      const {
        status,
        message,
        data,
      } = await getPageListSCFI({
        id: this.basicId,
        page: this.detailPage,
        rows: this.detailSize,
        type: this.searchForm.type,
      });
      if (status !== 0) return this.$message.warning(message);
      this.detailTable = data ? data.records : [];
      this.detailTotal = data ? data.total : 0;
    },
    async getPageListSOCI() {
      const {
        status,
        message,
        data,
      } = await getPageListSOCI({
        id: this.basicId,
        page: this.detailPage3,
        rows: this.detailSize3,
      });
      if (status !== 0) return this.$message.warning(message);
      this.detailTable3 = data ? data.records : [];
      this.detailTotal3 = data ? data.total : 0;
    },
    async getOtherData() {
      this.addVisible = false;
      const {
        status,
        message,
        data,
      } = await getPageListSOCI({
        id: this.basicId,
        page: 1,
        rows: 10,
      });
      if (status !== 0) return this.$message.warning(message);
      this.tableData2 = data ? data.records : [];
    },
    //模板下载
    download() {
      window.location.href = '/file/委托商托运费核对.xlsx';
    },
    beforeUpload(file) {
      this.tableLoad1 = true;
      this.uploadDis = true;
      if (file.name.split('.')[file.name.split('.').length - 1] == 'xls' || file.name.split('.')[file.name.split('.').length - 1] == 'xlsx') {
        this.uploadData.mFile = file.name;
      } else {
        this.uploadDis = false;
        this.tableLoad1 = false;
        this.$message.error('请选择excel文件导入！！！');
        return false;
      }
    },
    uploadHttp(content) {
      let formData = new FormData();
      formData.append('file', content.file, content.file.name);
      console.log(content);
      console.log(formData);
      let that = this;
      this.$axios({
        method: 'post',
        url: content.action + '&id=' + that.basicId,
        timeout: 600 * 1000,
        data: formData,
        headers: { 'content-type': 'multipart/form-data' },
      })
        .then(res => {
          this.uploadDis = false;
          this.tableLoad1 = false;
          this.$alert(res.data.message, '提示', {
            confirmButtonText: '关闭',
            callback: async () => {
              this.tableData1 = res.data.data;
            },
          });
          // that._transportPlanCvPageList()
        })
        .catch(error => {
          if (error.response) {
            that.$message.error('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
            console.log('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
          } else if (error.request) {
            that.$message.error('配时文件上传失败，服务器端无响应');
            console.log('配时文件上传失败，服务器端无响应');
          } else {
            that.$message.error('配时文件上传失败，请求封装失败');
            console.log('配时文件上传失败，请求封装失败');
          }
          this.uploadDis = false;
          this.tableLoad1 = false;
        });
    },
    /**
     * 核对对账单 导入 成功函数
     * @param res 上传成功回调
     */
    planOnSuccess(res) {
      this.uploadDis = false;
      this.tableLoad1 = false;
      if (res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      // this._transportPlanCvPageList()
      // this.TableDatas = res.data;
      this.$forceUpdate();
    },
    fillInInvoice(id) {
      this.$refs.invoiceInformation.openDialog(id);
    },
    addContractPrice(id) {
      this.$refs.addContractPrice.openDialog(id, 1);
    },
    async exportDatas() {
      window.exportExcelAllFunc({
        type: 'get',
        url: '/customer/account/export',
        obj: {
          ...this.searchForm,
          id: this.checkTableData.map(item => item.id).join(',')
        }
      });
    },
    // 导出数据
    async exportData() {
      let token = getSessionStore('token');
      const ids = [];
      this.checkTableData.forEach(item => {
        ids.push(item.id);
      });
      const exportParams = {
        ...this.searchForm,
        ids: ids,
      };
      window.exportExcel(baseUrl + `/platform/customer/accountPrice/export?access_token=${token}`, exportParams,  '委托商托运费补结算对账单资源车结算数据');
      this.clearCheckTableData();
    },
    searchCopyFormat(value, flag) {
      let splitArr = value.clipboardData.getData('Text')
        .replace(/\s/g, ',')
        .split(',');
      splitArr = splitArr.filter(item => item);
      splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
      switch (flag) {
        case 'frameNumber':
          this.oilPriceLinkageSearchForm.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
          break;
      }
    },
    addOilPriceLinkage() {
      if (this.checkData.length === 0) return this.$message.warning('请选择数据后添加油价联动！');
      this.$refs.addOilPriceLinkageFormRef.dialogOpen(this.checkData);
    },
    selectionChange(selection) {
      this.checkData = selection;
    },
    selectionDataChange(selection) {
      this.checkTableData = selection;
    },
    rowStyle({ row }) {
      return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
    },
    clearCheckData() {
      this.$refs.registerTable.clearSelection();
      this.checkData = [];
      this.searchOilPriceLinkage();
    },
    clearCheckTableData() {
      this.$refs.listTable.clearSelection();
      this.checkTableData = [];
      this.accountList();
    },
    async searchOilPriceLinkage() {

      this.tableLoading = true;
      // const {
      //   status,
      //   message,
      //   data,
      // } = await oilPriceLinkageQuery(this.oilPriceLinkageSearchForm);
      const {
        status,
        message,
        data,
      } = await oilPriceLinkQueryByRsi({
        id: this.id,
        page: 1,
        rows: 100,
      });
      console.log(this.id)
      this.tableLoading = false;
      if (status !== 0) return this.$message.warning(message);
      this.tableData = data ? data.records : [];
      this.total2 = data.total;
    },
    async submitBillingClick(id) {
      // this.invoicingLoading = true;
      // const {
      //   status,
      //   message,
      //   data,
      // } = await incomeSubmitInvoiceDetail({ id });
      // this.invoicingLoading = false;
      // if (status !== 0) return this.$message.warning(message);
      this.$refs.submitBillingRef.invoicingOpen({ id: 1 });
    },
    cancelPush(id) {
      this.$confirm('确定要取消推送当前数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { status, message, } = await cancellation({ id });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        await this.accountList();
      }).catch(() => {
      });
    },
    async dataPush(id,reconciliator, scope) {
      this.activeRow = scope.row;
      let productNumber = await paramCategoryPageList({
        value: '',
        status: '',
        rows: 9999,
        Page: 1,
        classaName: '',
        states: '',
        paramId: 'ac81ffe0197e4de19b7137dcb98f7784',
      });
      if (productNumber.status !== 0) return this.$message.warning(productNumber.message);

      this.productNumberOption = productNumber.data.records;

      let invoiceTypes = await paramCategoryPageList({
        value: '',
        status: '',
        rows: 9999,
        Page: 1,
        classaName: '',
        states: '',
        paramId: 'cf503167d28740f4b69aad91eb8dfd70',
      });
      if (invoiceTypes.status !== 0) return this.$message.warning(invoiceTypes.message);
      this.invoiceTypeOption = invoiceTypes.data.records;

      this.formPush.invoiceType = '';
      this.formPush.classbName = '';
      this.dialogFormVisiblePush = true;
      // this.$confirm('确定要推送当前数据吗？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      // }).then(async () => {
      //   const { status, message, } = await dataPush(id,reconciliator);
      //   if (status !== 0) return this.$message.warning(message);
      //   this.$message.success(message);
      //   await this.accountList();
      // }).catch(() => {
      // });
    },
    async titleChange(id,reconciliator) {
      this.$prompt('标题', '更改标题', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
      })
        .then(async ({ value }) => {
          const {
            status,
            message,
          } = await changeTitle({
            id,
            title: value,
            reconciliator
          });
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          await this.accountList();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消修改',
          });
        });
    },
    async submitBilling(invoiceManageList) {
      const {
        status,
        message,
      } = await incomeSubmitInvoiceAdd({ invoiceManageList });
      this.$refs.submitBillingRef.invoicingLoading = false;
      if (status !== 0) return this.$message.warning(message);
      this.$refs.submitBillingRef.invoicingClose();
      this.$message.success(message);
    },
  },
};
</script>

<style lang='scss' scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;


  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }

  .line+span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .navContainer p {
      display: inline-block;
      width: 90px;
      text-align: right;
    }

    &Container {
      width: 200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;

      p {
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tableContainer {
      margin-top: 15px;
      margin-bottom: 25px;
      width: 100%;

      ::v-deep {
        .el-table__expand-icon:after {
          content: '';
        }

        .el-table__expand-icon>i {
          /*display: none;*/
        }

        .el-table__expand-column {
          border-right: none;
        }

        body .el-table th.gutter {
          display: table-cell !important;
        }

        .el-badge__content {
          top: 4px !important;
          right: 1px !important;
        }

        .el-badge__content {
          background-color: #F56C6C !important;
        }

        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  .carContainer {
    width: 100%;
    padding: 15px 40px 10px 20px;
    max-height: 75vh;
    overflow: auto;

    &Title {
      display: flex;
      flex-direction: column;

      span {
        color: #101010;
        font-weight: 700;
        margin-bottom: 5px;
      }

      &Content {
        width: 100%;
        padding-left: 15px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 10px;

        &Item {
          height: 25px;
          padding: 0 5px;
          background-color: #a4adb3;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-right: 10px;
          margin-bottom: 5px;

          i {
            color: #000;
            font-size: 17px;
            cursor: pointer;
          }

          p {
            cursor: pointer;
          }
        }
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;

      button {
        margin: 0 15px;
      }
    }
  }

  .detail {
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height: 80vh;
    overflow: auto;

    ::v-deep {

      .el-table td,
      .el-table th {
        padding: 0;
      }

      .cell {
        font-size: 10px;
        padding: 0;
      }
    }

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;

        &Item {
          margin-bottom: 20px;

          .imgContainer {
            display: flex;
            align-items: center;
          }

          .span1 {
            font-weight: 700;
          }

          span {
            font-size: 14px;
          }

          .specialOne {
            width: 50%;
          }
        }

        .specialItem {
          display: flex;
        }
      }
    }

    .operation {
      display: flex;
      flex-direction: column;

      ::v-deep {
        .el-table .ui-warning-row {
          background-color: #fef0f0 !important;
        }

        .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover>td {
          background-color: #fef0f0 !important;
        }

        .el-table .ui-warning-row .cell {
          color: red;
        }
      }

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding: 0 20px;

        &Nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .reasonContainer {
    width: 100%;
    padding: 20px 30px;

    ::v-deep {
      .el-textarea__inner {
        min-height: 100px !important;
      }
    }

    .reasonBtn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .addCost {
    display: flex;
    flex-direction: column;
    padding: 10px 40px 10px 10px;
    max-height: 75vh;
    overflow: auto;

    &Nav {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    &Table {
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;

      ::v-deep {
        .el-table__expand-icon:after {
          content: '';
        }

        .el-table__expand-icon>i {
          display: none;
        }

        .el-table__expand-column {
          border-right: none;
        }

        body .el-table th.gutter {
          display: table-cell !important;
        }

        .el-table__header .el-table-column--selection .cell .el-checkbox:after {
          color: rgb(127, 127, 127);
          content: "全选";
          font-size: 12px;
          font-weight: 700;
          //margin-left: 2px;
        }

        .el-table__header .el-table-column--selection .cell .el-checkbox {
          margin-left: 8px;
        }

        .el-checkbox {
          margin-left: 16px;
        }

        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  .depart {
    width: 100%;
    padding: 10px 20px;
    max-height: 75vh;
    overflow: auto;

    &Table {
      margin-bottom: 25px;
      width: 100%;

      .tableAddBtnContainer {
        border: 1px solid #EBEEF5;
      ;
        border-top-style: none;
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 15px;

        .AddContainer {
          display: flex;
          align-items: center;

          &:hover {
            cursor: pointer;
          }
        }

        img {
          object-fit: cover;
          margin-right: 5px;
        }

        p {
          font-size: 13px;
          color: #F59A23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }
      }

      ::v-deep {
        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .specialItem {
      ::v-deep {
        .el-form-item__content {
          margin-left: 0 !important;
        }
      }
    }

    ::v-deep {
      .el-form-item__label {
        font-weight: 700;
      }

      .el-form-item {
        margin-bottom: 13px;
      }

      .el-form-item__label {
        padding: 0;
      }

      .el-form-item__content {
        position: relative;
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;

      button {
        margin: 0 15px;
      }
    }
  }

  ::v-deep {
    .el-table th>.cell {
      font-weight: 700 !important;
    }
  }
}

::v-deep {
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .el-dialog__headerbtn {
    top: 9px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.spanStyle {
  color: rgb(51, 136, 255);
  cursor: pointer;
  margin-left: 10px;
}

.iconError {
  font-size: 20px;

  i:hover {
    color: #00e1ff;
  }
}

.el-select {
  width: 165px;
}

.el-range-editor {
  width: 220px;
}
.btnTopBottom10 {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
